import React from 'react';
import { IconProps } from './types/Icon.type';

function Close48Icon(props: IconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="12.6875"
        y="14.0996"
        width="2"
        height="30"
        rx="1"
        transform="rotate(-45 12.6875 14.0996)"
        fill={props.fill || '#121212'}
      />
      <rect
        x="33.8984"
        y="12.6855"
        width="2"
        height="30"
        rx="1"
        transform="rotate(45 33.8984 12.6855)"
        fill={props.fill || '#121212'}
      />
    </svg>
  );
}

export default Close48Icon;
